import Components from "../../components";
const PrivacyPolicy = ({ data }) => {
  return (
    <div>
      <Components.PageHeader
        id="page-header"
        label="Page Header"
        title="Gizlilik Politikası"
        safeArea={data?.system?.safeArea}
        pixelRatio={data?.system?.pixelRatio}
      />
      <div
        style={{
          fontSize: "12px",
          paddingLeft: "20px",
          paddingRight: "20px",
          paddingBottom: "100px",
        }}
      >
        <div>
      <div
        className="shopify-policy__title"
        style={{
          borderColor: "rgb(229, 231, 235)",
          color: "rgb(0, 0, 0)",
          fontSize: "16px",
          fontWeight: 400,
        }}
      >
        <h1
          style={{
            borderColor: "rgb(229, 231, 235)",
            fontSize: "2.25rem",
            fontWeight: "var(--font-weight-header)",
            color: "var(--color-heading-text)",
          }}
        >
          Gizlilik politikası
        </h1>
      </div>

      <div
        className="shopify-policy__body"
        style={{
          borderColor: "rgb(229, 231, 235)",
          color: "rgb(0, 0, 0)",
          fontSize: "16px",
          fontWeight: 400,
        }}
      >
        <div
          className="rte"
          style={{
            borderColor: "rgb(229, 231, 235)",
          }}
        >
          <p>
            Firmamız, çeşitli amaçlarla kişisel veriler toplayabilir. Aşağıda,
            toplanan kişisel verilerin nasıl ve ne şekilde toplandığı, bu
            verilerin nasıl ve ne şekilde korunduğu belirtilmiştir.
          </p>

          <p>
            Üyelik veya sitemiz üzerindeki çeşitli form ve anketlerin
            doldurulması suretiyle üyelerin kendileriyle ilgili bir takım
            kişisel bilgileri (isim-soy isim, firma bilgileri, telefon, adres
            veya e-posta adresleri gibi) sitemiz tarafından işin doğası gereği
            toplanmaktadır.
          </p>

          <p>
            Firmamız bazı dönemlerde müşterilerine ve üyelerine kampanya
            bilgileri, yeni ürünler hakkında bilgiler, promosyon teklifleri
            gönderebilir. Üyelerimiz bu gibi bilgileri alıp almama konusunda her
            türlü seçimi üye olurken yapabilir, sonrasında üye girişi yaptıktan
            sonra hesap bilgileri bölümünden bu seçimi değiştirilebilir ya da
            kendisine gelen bilgilendirme iletisindeki linkle bildirim
            yapabilir.
          </p>

          <p>
            Sitemiz üzerinden veya e-posta ile gerçekleştirilen onay sürecinde,
            üyelerimiz tarafından sitemize elektronik ortamdan iletilen kişisel
            bilgiler, Üyelerimiz ile yaptığımız 'Kullanıcı Sözleşmesi' ile
            belirlenen amaçlar ve kapsam dışında üçüncü kişilere
            açıklanmayacaktır.
          </p>

          <p>
            Firmamız, Üyelik Sözleşmesi ile belirlenen amaçlar ve kapsam dışında
            da, talep edilen bilgileri kendisi veya işbirliği içinde olduğu
            kişiler tarafından doğrudan pazarlama yapmak amacıyla kullanabilir.
            Kişisel bilgiler, gerektiğinde kullanıcıyla temas kurmak için de
            kullanılabilir. Firmamız tarafından talep edilen bilgiler veya
            kullanıcı tarafından sağlanan bilgiler veya sitemiz üzerinden
            yapılan işlemlerle ilgili bilgiler; Firmamız ve işbirliği içinde
            olduğu kişiler tarafından, 'Üyelik Sözleşmesi' ile belirlenen
            amaçlar ve kapsam dışında da, üyelerimizin kimliği ifşa edilmeden
            çeşitli istatistiksel değerlendirmeler, veri tabanı oluşturma ve
            pazar araştırmalarında kullanılabilir.
          </p>

          <p>
            Firmamız, gizli bilgileri kesinlikle özel ve gizli tutmayı, bunu bir
            sır saklama yükümü olarak addetmeyi ve gizliliğin sağlanması ve
            sürdürülmesi, gizli bilginin tamamının veya herhangi bir kısmının
            kamu alanına girmesini veya yetkisiz kullanımını veya üçüncü bir
            kişiye ifşasını önlemek için gerekli tüm tedbirleri almayı ve
            gerekli özeni göstermeyi taahhüt etmektedir.
          </p>

          {/* --- Buradan sonrası uzun metinler aynı şekilde p etiketleri içinde devam edecek --- */}

          <p>
            KREDİ KARTI GÜVENLİĞİ <br />
            Firmamız, alışveriş sitelerimizden alışveriş yapan kredi kartı
            sahiplerinin güvenliğini ilk planda tutmaktadır. Kredi kartı
            bilgileriniz hiçbir şekilde sistemimizde saklanmamaktadır.
          </p>

          {/* Devam eden tüm <br> etiketlerini <p> bloklarına dönüştürmek en iyi pratik olur */}
          {/* Aşağıdaki iletişim bilgileri örnek: */}

          <div
            className="rte"
            style={{
              fontSize: "16px",
              fontWeight: 400,
            }}
          >
            <p>Madde 1- Taraflar</p>
            <p>1.1. TİCARET ÜNVANI</p>
            <div className="rte">THESEZAR TEKSTİL SANAYİ TİCARET LİMİTED ŞİRKETİ</div>
            <p>
              Adı: THESEZAR TEKSTİL SANAYİ TİCARET LİMİTED ŞİRKETİ <br />
              Adresi: İSMET KAPTAN MAH. ŞEVKET ÖZÇELİK SK. GÜVEN İSHANI NO: 59
              İÇ KAPI NO: 514 KONAK / İZMİR
            </p>
            <div className="rte">VERGİ DAİRESİ</div>
            <div className="rte">KONAK</div>
            <p>
              Tel: +90 541 156 20 24 <br />
              E-Posta: info@thesezar.com
            </p>
          </div>
        </div>
      </div>
    </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
